import { get } from 'hooks/use-http/useHttp'
import { ITagSearchResponse } from './../../../common/types/hashtags.types'

export const fetchTagSearchResult = async (page = 1, pageSize = 5, searchQuery?: string) => {
  const response = await get(
    `search/tags/?page=${page}&pageSize=${pageSize}&dir=asc&topic=${searchQuery ? searchQuery : ''}`,
    {
      dieSilent: true
    }
  )

  return response as ITagSearchResponse
}

export const useHashtagsApi = () => {
  return {
    fetchTagSearchResult
  } as const
}
